import React from 'react';
import styles from '../style/Marquee.module.scss';

const Marquee = () => {
  // First row: Core technical and creative services
  const line1 = [
    "Full-Stack Development", 
    "UI/UX Design", 
    "Mobile Solutions", 
    "Digital Strategy",
    "SEO Optimization"
  ];

  // Second row: Agency identity and location
  const line2 = [
    "Evas-Agency", 
    "Based in Tangier", 
    "Marketing Experts", 
    "Creative Content",
    "Ai Specialists", 
    "Graphic Design"
  ];

  return (
    <section className={styles.marqueeSection}>
      {/* First Row: Moving forward */}
      <div className={styles.marqueeRow}>
        <div className={styles.track}>
          {[...line1, ...line1, ...line1].map((item, i) => (
            <div key={i} className={styles.item}>
              <span className={styles.text}>{item}</span>
              <span className={styles.spark}>✦</span>
            </div>
          ))}
        </div>
      </div>

      {/* Second Row: Moving in reverse */}
      <div className={styles.marqueeRow}>
        <div className={`${styles.track} ${styles.reverse}`}>
          {[...line2, ...line2, ...line2].map((item, i) => (
            <div key={i} className={styles.item}>
              <span className={styles.text}>{item}</span>
              <span className={styles.spark}>✦</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Marquee;